import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { showError, showSuccess } from '../../../../utils/Notifications';
import userRoleService from '../services/user-role.service';
import { UserRoleSaveRequestDto } from '../dto/request/user-role-save-request.dto';
import { UserRoleResponseDto } from '../dto/response/user-role-response.dto';
import { EnrichedUserRoleResponseDto } from '../dto/response/enriched-user-role-response.dto';

const initialState = {
  status: 'idle',
  userRoles: null as UserRoleResponseDto[] | null,
  userRole: null as UserRoleResponseDto | null,
  enrichedUserRoles: [] as EnrichedUserRoleResponseDto[],
  error: null as string | null,
};

export const fetchUserRoles = createAsyncThunk(
  'userRoles/fetchUserRoles',
  async () => {
    return await userRoleService.fetchUserRoles();
  }
);

// export const fetchUserRoleById = createAsyncThunk(
//   'userRoles/fetchUserRoleById',
//   async (id: string) => {
//     return await userRoleService.fetchUserRoleById(id);
//   }
// );

export const createUserRole = createAsyncThunk(
  'userRoles/createUserRole',
  async (data: UserRoleSaveRequestDto) => {
    return await userRoleService.createUserRole(data);
  }
);

// export const updateUserRole = createAsyncThunk(
//   'userRoles/updateUserRole',
//   async (payload: { id: string; userRole: UserRoleSaveRequestDto }) => {
//     const { id, userRole } = payload;
//     return await userRoleService.updateUserRole(id, userRole);
//   }
// );

export const deleteUserRole = createAsyncThunk(
  'userRoles/deleteUserRole',
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      await userRoleService.deleteUserRole(id);
      dispatch(fetchUserRoles());
    } catch (e) {
      return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
    }
  }
);

export const enrichUserRoles = createAsyncThunk(
  'userRoles/enrichUserRoles',
  async (userRoles: UserRoleResponseDto[]) => {
    const enrichedRoles = await userRoleService.enrichUserRoles(userRoles);
    return enrichedRoles.filter(
      (role: EnrichedUserRoleResponseDto) => role.contextEntityName !== null
    );
  }
);

const userRoleSlice = createSlice({
  name: 'userRoleSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserRoles.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUserRoles.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.userRoles = action.payload;
      })
      .addCase(fetchUserRoles.rejected, (state, action) => {
        state.status = 'failed';
        showError(`Fetch userRoles failed. ${action.payload as string}`);
        state.error = action.error?.message ?? null;
      })
      // .addCase(fetchUserRoleById.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchUserRoleById.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.userRole = action.payload;
      // })
      // .addCase(fetchUserRoleById.rejected, (state, action) => {
      //   state.status = 'failed';
      //   showError(`Fetch userRole failed. ${action.payload as string}`);
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(createUserRole.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createUserRole.fulfilled, (state, action) => {
        state.status = 'succeeded';
        showSuccess(`UserRole created successfully.`);
        state.userRoles?.push(action.payload);
      })
      .addCase(createUserRole.rejected, (state, action) => {
        state.status = 'failed';
        showError(`Create userRole failed. ${action.payload as string}`);
        state.error = action.error?.message ?? null;
      })
      // .addCase(updateUserRole.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(updateUserRole.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   showSuccess(`UserRole updated successfully.`);
      //   if (state.userRoles) {
      //     const userRoleIndex = state.userRoles.findIndex(
      //       (userRole) => userRole.id === action.payload.id
      //     );
      //     if (userRoleIndex !== -1) {
      //       state.userRoles[userRoleIndex] = action.payload;
      //     }
      //   }
      // })
      // .addCase(updateUserRole.rejected, (state, action) => {
      //   state.status = 'failed';
      //   showError(`Update userRole failed. ${action.payload as string}`);
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(deleteUserRole.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteUserRole.fulfilled, (state) => {
        state.status = 'succeeded';
        showSuccess('UserRole deleted successfully.');
      })
      .addCase(deleteUserRole.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
        showError(`Deleting userRole failed. ${action.payload as string}`);
      })
      .addCase(enrichUserRoles.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(enrichUserRoles.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.enrichedUserRoles = action.payload;
      })
      .addCase(enrichUserRoles.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      });
  },
});

export default userRoleSlice.reducer;
